import { GetterTree } from 'vuex';
import { CourseModel } from '@descomplica/dex-models';
import { CourseState } from './state';
import RootState from '@/store/root_state';

const getters: GetterTree<CourseState, RootState> = {
  courseById: (state, coursesGetters) => (courseId: number) => {
    const course = state.courses[courseId.toString()];

    return course ? new CourseModel(course, coursesGetters) : undefined;
  },
  allCourses: (state, coursesGetters) => {
    return Object.values(state.courses).map((c: any) => new CourseModel(c, coursesGetters));
  },
  postgradCourses: (state) => {
    const courses = Object.values(state.courses);
    const postgradCourses = courses.filter((course) => {
      return course.descomplicaCategorySlug === 'pos';
    });

    return postgradCourses;
  },
};

export default getters;
